// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/cis_contract_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { CisContractService } from "./cis_contract_service_pb";

/**
 * ImportCisContracts は CIS契約マスタ CSV 取込を検証・反映する
 * (docs/specs/admin/data/uploads/cis-contract-master.md)。acting_member_id は
 * 露出させず BFF が eauth セッションから補完する。
 *
 * @generated from rpc bffuser.v1.CisContractService.ImportCisContracts
 */
export const importCisContracts = CisContractService.method.importCisContracts;

/**
 * ExportCisContracts は組織内の論理削除されていない供給地点マスタ (CIS契約マスタ)
 * 全行を CSV エクスポート用に返す (uploads/common.md §6, AC-DUC-028/029)。
 *
 * @generated from rpc bffuser.v1.CisContractService.ExportCisContracts
 */
export const exportCisContracts = CisContractService.method.exportCisContracts;
